import type { ReactNode } from 'react'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { cm } from '../../utils'

interface Props {
  href: string
  children: ReactNode
  className?: string
  target?: string
}

export function Link({ href, children, className, target }: Props) {
  const link = href.replace('https//', '').replace('https://https://', 'https://')

  // Determine if this is an internal or external link
  const isExternal =
    link.startsWith('http://') ||
    link.startsWith('https://') ||
    link.startsWith('mailto:') ||
    link.startsWith('tel:')

  // Always use regular anchor tag for external links or when target="_blank"
  if (isExternal || target === '_blank') {
    return (
      <a
        href={link}
        className={cm('text-[#65558f] hover:underline ml-1', className)}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      >
        {children}
      </a>
    )
  }

  // Use React Router Link for internal navigation
  return (
    <RouterLink to={link} className={cm('text-[#65558f] hover:underline ml-1', className)}>
      {children}
    </RouterLink>
  )
}
